import { useMemo } from 'react';
import { Field, FieldTypes } from '@common-fe/common-fe';
import dayjs from 'dayjs';
import * as yup from 'yup';

import { VALIDATORS } from '@/common';
import {
  DEFAULT_DATE_FORMAT,
  REQUIRED_TEXT,
} from '@/common/constants';
import { useFieldsWithDefaultValues } from '@/utils';

import { useGeneralInfoStore } from '../stores';


const REQUIRED_VALIDATOR = yup.string().trim().required(REQUIRED_TEXT);
const VALIDATOR = yup.string().trim().nullable();

const useGeneralInfoFields = (
  isEditMode?: boolean,
  isShowErrors?: boolean,
) => {
  const defaultFields = useGeneralInfoStore((state) => state.sourceState);



  const commonFields = useMemo<Field[]>(() => [{
    name: 'gender',
    type: FieldTypes.Radio,
    label: 'Gender',
    disabled: !isEditMode,
    options: [{
      value: 'M',
      label: 'Male',
    }, {
      value: 'F',
      label: 'Female',
    }, {
      value: 'O',
      label: 'Other',
    }],
    placeholder: 'Select gender',
  }], [isEditMode]);

  const fields = useMemo<Field[]>(() => [
    {
      name: 'firstName',
      type: FieldTypes.Text,
      label: 'First name',
      disabled: !isEditMode,
      placeholder: 'Enter first name',
      showRequireIcon: true,
      validator: REQUIRED_VALIDATOR,
    },
    {
      name: 'middleName',
      type: FieldTypes.Text,
      label: 'Middle name',
      disabled: !isEditMode,
      placeholder: 'Enter middle name',
      validator: VALIDATOR,
    },
    {
      name: 'lastName',
      type: FieldTypes.Text,
      label: 'Last name',
      disabled: !isEditMode,
      placeholder: 'Enter last name',
      showRequireIcon: true,
      validator: REQUIRED_VALIDATOR,
    },
    {
      name: 'suffix',
      type: FieldTypes.Text,
      label: 'Suffix',
      disabled: !isEditMode,
      inputWrapCssClass: 'small-input',
      placeholder: 'Enter suffix',
      validator: VALIDATOR,
    },
    {
      name: 'birthDate',
      type: FieldTypes.Date,
      inputWrapCssClass: 'small-input',
      isManualDateInput: true,
      label: 'Date of birth',
      showRequireIcon: true,
      disabled: !isEditMode,
      placeholder: DEFAULT_DATE_FORMAT,
      validator: VALIDATORS.DATE_FORMAT_MAX_TODAY.required(REQUIRED_TEXT),
    },
    ...commonFields,
  ], [isEditMode, commonFields]);

  const viewFields = useMemo<Field[]>(() => {
    const years = dayjs(defaultFields?.birthDate, DEFAULT_DATE_FORMAT).diff(dayjs(), 'years');
    return [
      {
        name: 'fullName',
        type: FieldTypes.Text,
        label: 'Full name',
        disabled: true,
        placeholder: 'Enter full name',

      },

      {
        name: 'birthDateFormated',
        type: FieldTypes.Text,

        label: 'Date of birth',
        showRequireIcon: true,
        disabled: true,
        value: defaultFields?.birthDate ? `${defaultFields?.birthDate} (${Math.abs(years || 0)} years)` : '',
        placeholder: DEFAULT_DATE_FORMAT,

      },
      ...commonFields,
    ];
  }, [commonFields, defaultFields]);

  const formattedFields = useFieldsWithDefaultValues(isEditMode ? fields
    : viewFields, defaultFields);

  return formattedFields;
};

export default useGeneralInfoFields;
